import * as React from 'react';

interface Props {
	stickyClassName?: string;
}

const Sticky: React.FC<Props> = ({ children, stickyClassName }) => {
	const containerRef = React.useRef<HTMLDivElement>(),
		noStickyContainerRef = React.useRef<HTMLDivElement>(),
		isFixed = React.useRef<boolean>(),
		containerTop = React.useRef<number>();

	const onScroll = () => {
		if (containerRef?.current) {
			const scrollTop = window.pageYOffset;

			if (!containerTop.current) {
				const rect = containerRef.current.getBoundingClientRect();
				containerTop.current = rect.top + scrollTop;
			}

			if (noStickyContainerRef.current) {
				const styles = window.getComputedStyle(containerRef.current),
					calculatedHeight =
						containerRef.current.offsetHeight +
						parseInt(styles.paddingBottom) +
						parseInt(styles.paddingTop) +
						parseInt(styles.marginBottom) +
						parseInt(styles.marginTop);

				noStickyContainerRef.current.style.height = `${calculatedHeight}px`;
			}

			if (!isFixed.current && scrollTop >= containerTop.current) {
				containerRef.current.style.position = 'fixed';
				containerRef.current.style.top = '0px';
				if (stickyClassName) {
					containerRef.current.classList.add(stickyClassName);
				}

				isFixed.current = true;
			} else if (isFixed && scrollTop < containerTop.current) {
				containerRef.current.style.position = 'relative';
				if (stickyClassName) {
					containerRef.current.classList.remove(stickyClassName);
				}

				isFixed.current = false;
			}
		}
	};

	React.useEffect(() => {
		window.addEventListener('scroll', onScroll);

		return () => {
			window.removeEventListener('scroll', onScroll);
		};
	});

	return (
		<div ref={noStickyContainerRef}>
			<div ref={containerRef}>{children}</div>
		</div>
	);
};

export default Sticky;
